// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".scrollToTopLink[data-v-2bce04ab]{width:50px;height:50px;background-color:#02bd0f;color:#fff;position:fixed;right:0;bottom:-100px;text-align:center;border-radius:50px;font-weight:700;padding:6px 0;box-shadow:0 2px 8px 5px #ccc;transition:all .3s}.scrollToTopLink[data-v-2bce04ab]:hover{background-color:#017806}.showScrollTopButton[data-v-2bce04ab]{bottom:15px}", ""]);
// Exports
module.exports = exports;
